<template>
  <!-- 商品分类 => 门店列表 -->
  <div>
    <!-- 页面布局 -->
    <!-- <wPageCrumbs> -->
    <!-- 商品分类区域 -->
    <div class="wGC-categoryArea">
      <div class="wGC-head">
        <!-- 栏目 -->
        <div class="wGCH-column">
        
        </div>
        <div class="wGCH-operate">
          <el-button type="primary" @click="wDoTableBtn('', 'add')">新增门店</el-button>
        </div>
      </div>

      <!-- 商品分类数据 -->
      <div class="wGC-categoryList">
        <!-- table表 -->
        <div class="wGLG-table">
          <el-table :data="wCategory.list" border style="width: 100%" v-loading="tableLoading">
            <el-table-column label="店铺名称" prop="storeName" width="200">
            </el-table-column>
            <el-table-column label="图片" width="150">
              <template slot-scope="scope">
                <el-image style="width: 100%" :src="scope.row.headImage" :preview-src-list="[scope.row.headImage]">
                </el-image>
              </template>
            </el-table-column>
            <el-table-column label="地址" prop="address"></el-table-column>
            <el-table-column label="银行账户" prop="bankCard"></el-table-column>
            <el-table-column label="桌位" prop="tableNumber" width="100">
              <template slot-scope="scope">
                <el-link type="success" @click="wToTableList(scope.row)">{{
                  scope.row.tableNumber
                  }}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="负责人" prop="beneficiaryName" width="100"></el-table-column>
            <el-table-column label="核销负责人" prop="veriperson" width="100" >
               <template slot-scope="scope">
                {{ scope.row.UserPhone }}
              </template>
            </el-table-column>
            <!-- <el-table-column label="核销负责人" prop="veriperson" width="100">
              <template slot-scope="scope">
                <span>{{ formatVeriperson(scope.row.veriperson) }}</span>   
              </template>
            </el-table-column> -->
            <!-- <el-table-column label="核销负责人" prop="veriperson" width="100"></el-table-column> -->
            <el-table-column label="是否回本" prop="isBreakEven" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isBreakEven == 1 ? 'success' : 'info'">
                  {{ scope.row.isBreakEven == 1 ? '已回本' : '未回本' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="月营业额" prop="turnover" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.turnover !== null && scope.row.turnover !== undefined">{{ scope.row.turnover }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="门店类型" prop="type" width="120">
              <template slot-scope="scope">
                <div v-if="scope.row.type">
                  <el-tag v-for="(t, index) in scope.row.type.split(',')" :key="index" style="margin-right: 4px; margin-bottom: 4px;">
                    {{ getTypeName(t) }}
                  </el-tag>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="经营方式" prop="atype" width="120">
              <template slot-scope="scope">
                <el-tag type="primary" v-if="scope.row.atype == 1">直营店</el-tag>
                <el-tag type="warning" v-else-if="scope.row.atype == 2">师徒制(旧改店)</el-tag>
                <el-tag type="success" v-else-if="scope.row.atype == 3">师徒制(合作店)</el-tag>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" prop="openOrCloseName" width="100">
              <template slot-scope="scope">
                <span :class="{ isOpenOrClose: scope.row.openOrClose == 1 }">{{
                  scope.row.openOrCloseName
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column label="开店时间" prop="openDate">
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="wDoTableBtn(scope,'edit')"><span>{{ scope.row.headImage ?
                  "查看信息" : "补录信息" }}</span>
                </el-button>
                <el-button type="text" size="small" @click="wDoTableBtn(scope, 'business')"><span>{{
                  scope.row.openOrClose == 0 ? "开始营业" : "暂停营业"
                    }}</span>
                </el-button>
                <el-button type="text" size="small" @click="wDoTableBtn(scope, 'delete')"><span>删除</span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="wPagination">
          <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="wCategory.page"
            :page-size="wCategory.limit" :total="wCategory.total" :page-sizes="[5, 10, 15, 20, 50]"
            :hide-on-single-page="false" @current-change="wELPageCurrentChange" @size-change="wELPageSizeChange">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- </wPageCrumbs> -->

    <!-- 新增/修改门店信息 -->
    <el-dialog :title="wStoreDialog.form.id ? '修改门店信息' : '新增门店信息'" :visible.sync="wStoreDialog.isShow"
      :close-on-click-modal="false" append-to-body @close="wStoreDialogClose()">
      <!-- 门店信息表单 -->
      <div class="wDialogForm">
        <vue-scroll :ops="wVueScrollOps">
          <div class="wDialogForm-box">
            <el-form ref="wStaffFrom" :model="wStoreDialog.form" label-width="100px">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="门店名称" prop="storeName">
                    <el-input v-model="wStoreDialog.form.storeName" placeholder="请输入门店名称"></el-input>
                    <!-- <span v-else>{{ wStoreDialog.form.storeName || "未知的门店名称" }}</span> -->
                  </el-form-item>
                </el-col>
              
                <el-col :span="16">
                  <el-form-item label="打印机编号" prop="sn">
                    <!-- <el-input type="textarea" v-model="wStoreDialog.form.address" placeholder="请输入门店地址"></el-input> -->
                    <el-select v-model="wStoreDialog.form.sn" clearable multiple filterable allow-create default-first-option
                      placeholder="输入打印机编号，用回车添加">
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="门店地址" prop="address">
                    <el-input type="textarea" v-model="wStoreDialog.form.address" placeholder="请输入门店地址"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="门店电话" prop="tel">
                    <el-input v-model="wStoreDialog.form.tel" placeholder="请输入门店电话"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="银行卡号" prop="bankCard">
                    <el-input v-model="wStoreDialog.form.bankCard" placeholder="请输入银行卡号"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="门店位置经度" prop="tel">
                    <el-input v-model="wStoreDialog.form.lon" placeholder="请输入地图经度值"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="门店位置纬度" prop="tel">
                    <el-input v-model="wStoreDialog.form.lat" placeholder="请输入地图纬度值"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="负责人" prop="beneficiary">
                    <el-button @click="selectBeneficiary">{{ wStoreDialog.form.beneficiary ? '已选择' +
                      wStoreDialog.form.beneficiaryName : '选择' }}</el-button>
                  </el-form-item>
                </el-col>

                <el-col :span="16">
                  <el-form-item label="核销负责人" prop="UserPhone">
                    <el-button @click="selectVeriPerson">
                      {{ wStoreDialog.form.UserPhone||wStoreDialog.form.veripersonName ? wStoreDialog.form.UserPhone||wStoreDialog.form.veripersonName : '选择' }}
                    </el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="自提核销人" prop="pickupperson">
                    <el-button @click="selectPickupperson">
                      {{ wStoreDialog.form.PickupPhone||wStoreDialog.form.pickuppersonName ? wStoreDialog.form.PickupPhone||wStoreDialog.form.pickuppersonName : '选择' }}
                    </el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="商品品质" prop="quality">
                    <el-input v-model="wStoreDialog.form.quality" placeholder="请输入商品品质"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="发货时效" prop="delivery">
                    <el-input v-model="wStoreDialog.form.delivery" placeholder="请输入发货时效"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="客服响应" prop="corresponding">
                    <el-input v-model="wStoreDialog.form.corresponding" placeholder="请输入客服响应"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="是否回本" prop="isBreakEven">
                    <el-radio-group v-model="wStoreDialog.form.isBreakEven">
                      <el-radio :label="0">否 / 未回本</el-radio>
                      <el-radio :label="1">是 / 已回本</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="门店类型" prop="type">
                    <el-select v-model="wStoreDialog.form.type" multiple placeholder="请选择门店类型" style="width: 100%">
                      <el-option label="全牛小面" value="QNXM"></el-option>
                      <el-option label="非遗酸汤火锅" value="FYST"></el-option>
                      <el-option label="香辣牛骨锅" value="XLNG"></el-option>
                      <el-option label="韩式烤肉" value="HSKR"></el-option>
                      <el-option label="牧歌烧烤" value="MGSK"></el-option>
                      <el-option label="广式烤鸭(饭)" value="GSKY"></el-option>
                      <el-option label="美式炸鸡" value="MSZJ"></el-option>
                      <el-option label="牧歌牛包子" value="MGBZ"></el-option>
                      <el-option label="铜锅涮肉" value="TGSR"></el-option>
                      <el-option label="辣辣卤鸭货" value="LLYH"></el-option>
                      <el-option label="重庆毛肚火锅" value="CQHG"></el-option>
                      <el-option label="社区卤菜厨房" value="SQCF"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="经营方式" prop="atype">
                    <el-select v-model="wStoreDialog.form.atype" placeholder="请选择经营方式" style="width: 100%">
                      <el-option label="直营店" :value="1"></el-option>
                      <el-option label="师徒制(旧改店)" :value="2"></el-option>
                      <el-option label="师徒制(合作店)" :value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="16">
                  <el-form-item :label="wStoreDialog.form.atype === 2 ? '原营业额' : '月营业额'" prop="turnover" v-if="wStoreDialog.form.atype === 2 || wStoreDialog.form.atype === 3">
                    <el-input v-model="wStoreDialog.form.turnover" :placeholder="wStoreDialog.form.atype === 2 ? '请输入原营业额' : '请输入月营业额'"></el-input>
                  </el-form-item>
                </el-col>
                
                <el-col :span="24">
                  <el-form-item label="开始运营" prop="startTime">
                    <el-time-select placeholder="起始时间" v-model="wStoreDialog.form.startTime"
                      :picker-options="{ start: '08:30', step: '00:15', end: '23:30' }" />
                  </el-form-item>
                  <el-form-item label="结束运营" prop="endTime">
                    <el-time-select placeholder="结束时间" v-model="wStoreDialog.form.endTime"
                      :picker-options="{ start: '08:30', step: '00:15', end: '23:30', minTime: wStoreDialog.form.startTime }" />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-row type="flex" class="row-bg">
                    <el-form-item label="门店主图">
                      <el-upload :action="wGetUploadImgPath()" list-type="picture-card"
                        :limit="wStoreDialog.form.imgCover.limit" :file-list="wStoreDialog.form.imgCover.list_v"
                        :on-preview="wELUpload_preview" :on-remove="wELUpload_remove_cover"
                        :on-success="wELUpload_success_cover" :on-error="wELUpload_error" :on-exceed="wELUpload_limit"
                        :before-upload="wELUpload_beforeUpload">
                        <i class="el-icon-plus"></i>
                        <div slot="tip" class="el-upload__tip">
                          只能上传jpg/png文件，推荐尺寸: 630 * 420
                        </div>
                      </el-upload>
                    </el-form-item>
                  </el-row>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </vue-scroll>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="wStoreDialog.isShow = false">取 消</el-button>
        <el-button type="primary" @click="wDoStoreDialogOperate">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 图片预览 -->
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>

    <!-- 负责人 -->
    <el-dialog title="负责人" :visible.sync="beneficiary.isShow" append-to-body :close-on-click-modal="false">
      <!-- 搜索区 -->
      <div class="wETJRFSerach-area">
        <el-input style="width: 100%; max-width: 400px" type="text" v-model="beneficiary.keyword" maxlength="11"
          placeholder="请输入手机号"></el-input>
        <el-button type="primary" @click="wETJRFSerachBtn">搜索</el-button>
      </div>
      <!-- 表格数据区 -->
      <div class="wETJRFTable-area">
        <el-table :data="beneficiary.list" style="width: 100%">
          <el-table-column label="会员">
            <template slot-scope="scope">
              <div class="wETJRFTable-user">
                <el-avatar :size="30" :src="scope.row.avatar"></el-avatar>
                <div class="wETJRFTable-userName">{{ scope.row.nickName }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号"> </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="wETJRFSerachChoice(scope.row)">
                选择
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="wPagination">
          <el-pagination background layout="total, prev, pager, next, jumper" :current-page="beneficiary.page"
            :page-size="beneficiary.limit" :total="beneficiary.total" :hide-on-single-page="false"
            @current-change="wELPageCurrentChange_edit" @size-change="wELPageSizeChange_edit">
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <!-- 核销负责人弹窗 -->
    <el-dialog title="核销负责人" :visible.sync="veriperson.isShow" append-to-body :close-on-click-modal="false" width="800px">
      <!-- 已选择区域 -->
      <div class="selected-persons-area" v-if="veriperson.selectedList.length > 0">
        <div class="selected-persons-label">已选择：</div>
        <div class="selected-persons-tags">
          <el-tag
            v-for="person in veriperson.selectedList"
            :key="person.id"
            closable
            @close="removeSelectedPerson(person.id)"
            style="margin-right: 8px; margin-bottom: 8px;"
          >
            {{ person.nickName }}
          </el-tag>
        </div>
        <el-button type="primary" size="small" @click="confirmSelection" style="margin-left: 10px;">
          确认
        </el-button>
      </div>
      
      <!-- 搜索区 -->
      <div class="wETJRFSerach-area" style="margin-top: 16px;">
        <el-input 
          style="width: 100%; max-width: 400px" 
          type="text" 
          v-model="veriperson.keyword" 
          maxlength="11"
          placeholder="请输入手机号"
          @keyup.enter.native="wETJRFSerachBtn2"
        ></el-input>
        <el-button type="primary" @click="wETJRFSerachBtn2">搜索</el-button>
      </div>
      
      <!-- 表格数据区 -->
      <div class="wETJRFTable-area" style="margin-top: 16px;">
        <el-table :data="veriperson.list" style="width: 100%">
          <el-table-column label="会员">
            <template slot-scope="scope">
              <div class="wETJRFTable-user">
                <el-avatar :size="30" :src="scope.row.avatar"></el-avatar>
                <div class="wETJRFTable-userName">{{ scope.row.nickName }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号"> </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                @click="wETJRFSerachChoice2(scope.row)"
                :disabled="isPersonSelected(scope.row.id)"
              >
                {{ isPersonSelected(scope.row.id) ? '已选择' : '选择' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="wPagination">
          <el-pagination 
            background 
            layout="total, prev, pager, next, jumper" 
            :current-page="veriperson.page"
            :page-size="veriperson.limit" 
            :total="veriperson.total" 
            :hide-on-single-page="false"
            @current-change="wELPageCurrentChange_edit2" 
            @size-change="wELPageSizeChange_edit2">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 自提核销人弹窗 -->
    <el-dialog title="自提核销人" :visible.sync="pickupperson.isShow" append-to-body :close-on-click-modal="false" width="800px">
      <div class="selected-persons-area" v-if="pickupperson.selectedList.length > 0">
        <div class="selected-persons-label">已选择：</div>
        <div class="selected-persons-tags">
          <el-tag
            v-for="person in pickupperson.selectedList"
            :key="person.id"
            closable
            @close="removeSelectedPickupPerson(person.id)"
            style="margin-right: 8px; margin-bottom: 8px;"
          >
            {{ person.nickName || person.phone || person.id }}
          </el-tag>
        </div>
        <el-button type="primary" size="small" @click="confirmPickupSelection" style="margin-left: 10px;">
          确认
        </el-button>
        <el-button type="warning" size="small" @click="clearPickupSelection" style="margin-left: 8px;">
          清空
        </el-button>
      </div>
      <div class="wETJRFSerach-area" style="margin-top: 16px;">
        <el-input style="width: 100%; max-width: 400px" type="text" v-model="pickupperson.keyword" maxlength="11" placeholder="请输入手机号" @keyup.enter.native="wETJRFSerachBtn_pick"></el-input>
        <el-button type="primary" @click="wETJRFSerachBtn_pick">搜索</el-button>
      </div>
      <div class="wETJRFTable-area" style="margin-top: 16px;">
        <el-table :data="pickupperson.list" style="width: 100%">
          <el-table-column label="会员">
            <template slot-scope="scope">
              <div class="wETJRFTable-user">
                <el-avatar :size="30" :src="scope.row.avatar"></el-avatar>
                <div class="wETJRFTable-userName">{{ scope.row.nickName }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号"> </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                @click="wETJRFSerachChoice_pick(scope.row)"
                :disabled="isPickupPersonSelected(scope.row.id)"
              >
                {{ isPickupPersonSelected(scope.row.id) ? '已选择' : '选择' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="wPagination">
          <el-pagination background layout="total, prev, pager, next, jumper" :current-page="pickupperson.page" :page-size="pickupperson.limit" :total="pickupperson.total" :hide-on-single-page="false" @current-change="wELPageCurrentChange_edit_pick" @size-change="wELPageSizeChange_edit_pick">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import wPageCrumbs from "@/components/layout/PageCrumbs.vue";
import {
  store_storeUpdate,
  store_storeInfoById,
  store_editStoreInfo,
  store_addStoreInfo
} from "@/network/wApi.js";

import { deleteStoreApi,getUserInfoById } from "@/network/api";
export default {
  components: {
    wPageCrumbs
  },
  data() {
    return {
 
      re:"",
      tableLoading: false,
      // 栏目
      wColumn: {
        value: 0,
        options: [
          {
            id: 0,
            title: "全部"
          },
          {
            id: 1,
            title: "旗舰店"
          },
          {
            id: 2,
            title: "中心店"
          },
          {
            id: 3,
            title: "社区店"
          }
        ]
      },

      // 滚动条的配置
      wVueScrollOps: {
        scrollPanel: {
          scrollingX: false
        }
      },

      // 商品分类数据
      wCategory: {
        page: 1,
        limit: 10,
        total: 0,
        list: []
      },

      // 图片预览
      dialogImageUrl: "",
      dialogVisible: false,

      // 门店信息修改弹框
      wStoreDialog: {
        isShow: false, // 是否展示
        // 门店信息
        form: {
          id: 0, // id
          startTime: "",
          endTime: "",
          beneficiary: undefined,
          beneficiaryName: "",
          veriperson:"",
          veripersonName:"",//与UserPhone是一样的值
          UserPhone:"11",//与veripersonName是一样的值
          pickupperson: undefined,
          pickuppersonName: "",
          PickupPhone: "",
              quality: "",
              delivery: "",
              corresponding: "",
          isBreakEven: 0,
          type: ["QNXM"],
          atype: 1,
          turnover: null, // 月营业额
          storeName: "", // 门店名称
          address: "",
          sn: [],//打印机编号
          tel: "",
          bankCard: "",
          lan: '',
          lon: '',
          // 门店分类
          category: {
            value: "", // 选中值
            options: [
              {
                id: 1,
                label: "旗舰店"
              },
              {
                id: 2,
                label: "中心店"
              },
              {
                id: 3,
                label: "社区店"
              }
            ]
          },
          imgCover: {
            limit: 1, // 数量限制
            list: [], // 图片集合，更新以后的值
            list_v: [] // 修改数据默认值和list一样
          }, // 商品主图
          imgAlbum: {
            limit: 20, // 数量限制
            list: [], // 图片集合，更新以后的值
            list_v: [] // 修改数据默认值和list一样
          }, // 商品相册图
        }
      },

      beneficiary: {
        isShow: false,
        keyword: "",
        page: 1, // 分页
        limit: 10, // 条数
        total: 0, // 总数
        list: [] // 数据
      },

      veriperson: {
      id:[],
      isShow: false,
      keyword: '',
      page: 1,
      limit: 10,
      total: 0,
      list: [],
      selectedList: [] // 新增：存储已选择的负责人
    },
    pickupperson: {
      isShow: false,
      keyword: "",
      page: 1,
      limit: 10,
      total: 0,
      list: [],
      selectedList: []
    },

    };
  },
  created() {
    // 获取门店列表数据
    this.wGetStoreList();
  },

  methods: {
    getTypeName(type) {
      const map = {
        'QNXM': '全牛小面',
        'FYST': '非遗酸汤火锅',
        'XLNG': '香辣牛骨锅',
        'HSKR': '韩式烤肉',
        'MGSK': '牧歌烧烤',
        'GSKY': '广式烤鸭(饭)',
        'MSZJ': '美式炸鸡',
        'MGBZ': '牧歌牛包子',
        'TGSR': '铜锅涮肉',
        'LLYH': '辣辣卤鸭货',
        'CQHG': '重庆毛肚火锅',
        'SQCF': '社区卤菜厨房'
      };
      return map[type] || type;
    },

    // handleDialogOpen() {
    //   // 对话框打开时清空已选择的人员
    //   this.veriperson.selectedList = [];
    // },

    // formatVeriperson(row, column, cellValue, index){
    //   console.log(cellValue);
    //   this.idsArray = cellValue;
    //   // this.phones = [];
    //   // this.re="";
    //   for  (const key in this.idsArray){
    //     this.wGetStoreInfoById(this.idsArray[key]);
    //     this.phones[key]=res.beneficiaryName;
    //   }
    //   this.re=phones.join(',');
    //   console.log(this.re);
      
    //   return this.re;
    // },

    wETJRFSerachChoice(data) {
      this.wStoreDialog.form.beneficiary = data.id;
      this.wStoreDialog.form.beneficiaryName = data.nickName;
      this.beneficiary.isShow = false;
    },
    wETJRFSerachChoice_pick(data) {
      const isExist = this.pickupperson.selectedList.some(item => item.id === data.id);
      if (!isExist) {
        this.pickupperson.selectedList.push({
          id: data.id,
          nickName: data.nickName,
          phone: data.phone
        });
      }
    },
    selectBeneficiary() {
      this.wGetMemberBySearch();
    },
    selectPickupperson() {
      // 预填已选
      const idsStr = this.wStoreDialog.form.pickupperson || '';
      const namesStr = this.wStoreDialog.form.pickuppersonName || '';
      const phonesStr = this.wStoreDialog.form.PickupPhone || '';
      const ids = idsStr ? idsStr.split(',').filter(Boolean) : [];
      const names = namesStr ? namesStr.split(',') : [];
      const phones = phonesStr ? phonesStr.split(',') : [];
      if (ids.length > 0) {
        this.pickupperson.selectedList = ids.map((id, idx) => ({
          id,
          nickName: names[idx] || '',
          phone: phones[idx] || ''
        }));
      } else {
        this.pickupperson.selectedList = [];
      }
      this.wGetMemberBySearch_pick();
    },
    wETJRFSerachBtn() {
      // 更改当前页码数据
      this.beneficiary.page = 1;
      this.$nextTick(() => {
        // 获取搜索列表数据
        this.wGetMemberBySearch();
      });
    },
    wETJRFSerachBtn_pick() {
      this.pickupperson.page = 1;
      this.$nextTick(() => {
        this.wGetMemberBySearch_pick();
      });
    },
    wELPageSizeChange_edit(wP_cPageSize) {
      // 更改当前页码数据
      this.beneficiary.page = 1;
      this.beneficiary.limit = wP_cPageSize;
      this.$nextTick(() => {
        // 获取列表数据
        this.wGetMemberBySearch();
      });
    },
    wELPageSizeChange_edit_pick(wP_cPageSize) {
      this.pickupperson.page = 1;
      this.pickupperson.limit = wP_cPageSize;
      this.$nextTick(() => {
        this.wGetMemberBySearch_pick();
      });
    },
    wELPageCurrentChange_edit(wP_cPage) {
      // 更改当前页码数据
      this.beneficiary.page = wP_cPage;
      this.$nextTick(() => {
        // 获取列表数据
        this.wGetMemberBySearch();
      });
    },
    wELPageCurrentChange_edit_pick(wP_cPage) {
      this.pickupperson.page = wP_cPage;
      this.$nextTick(() => {
        this.wGetMemberBySearch_pick();
      });
    },
    // 移除自提核销人
    removeSelectedPickupPerson(personId) {
      const index = this.pickupperson.selectedList.findIndex(item => item.id === personId);
      if (index !== -1) {
        this.pickupperson.selectedList.splice(index, 1);
      }
    },
    // 是否已选择
    isPickupPersonSelected(personId) {
      return this.pickupperson.selectedList.some(item => item.id === personId);
    },
    // 确认自提核销人选择
    confirmPickupSelection() {
      if (this.pickupperson.selectedList.length === 0) {
        this.$message.warning('请至少选择一个自提核销人');
        return;
      }
      const ids = this.pickupperson.selectedList.map(item => item.id).join(',');
      const names = this.pickupperson.selectedList.map(item => item.nickName).join(',');
      const phones = this.pickupperson.selectedList.map(item => item.phone).join(',');
      this.wStoreDialog.form.pickupperson = ids;
      this.wStoreDialog.form.pickuppersonName = names;
      this.wStoreDialog.form.PickupPhone = phones;
      this.pickupperson.isShow = false;
    },
    // 清空自提核销人
    clearPickupSelection() {
      this.pickupperson.selectedList = [];
      this.wStoreDialog.form.pickupperson = '';
      this.wStoreDialog.form.pickuppersonName = '';
      this.wStoreDialog.form.PickupPhone = '';
    },
    wGetMemberBySearch() {
      // 请求参数
      let wData = {};
      // 查询条件
      let {
        keyword, // 搜索关键字
        page, // 分页
        limit // 条数
      } = this.beneficiary;
      // 判断条件
      if (keyword) {
        wData.phone = keyword;
      }
      wData["pageModel.pageNo"] = page;
      wData["pageModel.pageSize"] = limit;

      // 请求函数
      this.$api.member_list({
        data: wData,
        success: res => {
          // 更新数据
          this.beneficiary.total = res.total;
          this.beneficiary.list = res.records;
          // 打开弹框
          this.$nextTick(() => {
            this.beneficiary.isShow = true;     
          });
        }
      });
    },
    wGetMemberBySearch_pick() {
      let wData = {};
      let { keyword, page, limit } = this.pickupperson;
      if (keyword) {
        wData.phone = keyword;
      }
      wData["pageModel.pageNo"] = page;
      wData["pageModel.pageSize"] = limit;
      this.$api.member_list({
        data: wData,
        success: res => {
          this.pickupperson.total = res.total;
          this.pickupperson.list = res.records;
          this.$nextTick(() => {
            this.pickupperson.isShow = true;
          });
        }
      });
    },



    //行段多选择
    wETJRFSerachChoice2(data) {
    // 检查是否已经选择
    const isExist = this.veriperson.selectedList.some(item => item.id === data.id);
    if (!isExist) {
      this.veriperson.selectedList.push({
        id: data.id,
        nickName: data.nickName
      });
    }
  },

  // 移除已选择的核销负责人
  removeSelectedPerson(personId) {
    const index = this.veriperson.selectedList.findIndex(item => item.id === personId);
    if (index !== -1) {
      this.veriperson.selectedList.splice(index, 1);
    }
  },

  // 检查核销负责人是否已选择
  isPersonSelected(personId) {
    return this.veriperson.selectedList.some(item => item.id === personId);
  },

  // 确认选择
  confirmSelection() {
    if (this.veriperson.selectedList.length === 0) {
      this.$message.warning('请至少选择一个核销负责人');
      return;
    }

    // 拼接ID和名称，以逗号分隔
    const ids = this.veriperson.selectedList.map(item => item.id).join(',');
    const names = this.veriperson.selectedList.map(item => item.nickName).join(',');

    // 更新表单数据
    this.wStoreDialog.form.veriperson = ids;
    this.wStoreDialog.form.veripersonName = names;
    this.wStoreDialog.form.UserPhone = names;

    // 关闭弹窗
    this.veriperson.isShow = false;
    
    // 清空临时选择列表（可选，根据需求决定）
    // this.veriperson.selectedList = [];
  },

  selectVeriPerson() {
    // 打开弹窗前，如果有已选择的负责人，初始化selectedList
    if (this.veriperson.id && this.wStoreDialog.form.UserPhone) {
      const ids = this.veriperson.id;
      const names = this.wStoreDialog.form.UserPhone.split(',');
      this.veriperson.selectedList = ids.map((id, index) => ({
        id: id,
        nickName: names[index] || ''
      }));
      console.log('9999',this.veriperson.selectedList);
      
    } else {
      this.veriperson.selectedList = [];
    }
    // console.log('9999',this.wStoreDialog.form.UserPhone);
    console.log('8888888888888888',this.wStoreDialog.form.veriperson);
    this.wGetMemberBySearch2();
  },

  // 其他方法保持不变
  wETJRFSerachBtn2() {
    this.veriperson.page = 1;
    this.$nextTick(() => {
      this.wGetMemberBySearch2();
    });
  },
  
  wELPageSizeChange_edit2(wP_cPageSize) {
    this.veriperson.page = 1;
    this.veriperson.limit = wP_cPageSize;
    this.$nextTick(() => {
      this.wGetMemberBySearch2();
    });
  },
  
  wELPageCurrentChange_edit2(wP_cPage) {
    this.veriperson.page = wP_cPage;
    this.$nextTick(() => {
      this.wGetMemberBySearch2();
    });
  },
  
  wGetMemberBySearch2() {
    let wData = {};
    let {
      keyword,
      page,
      limit
    } = this.veriperson;
    
    if (keyword) {
      wData.phone = keyword;
    }
    wData["pageModel.pageNo"] = page;
    wData["pageModel.pageSize"] = limit;

    this.$api.member_list({
      data: wData,
      success: res => {
        this.veriperson.total = res.total;
        this.veriperson.list = res.records;
        this.$nextTick(() => {
          this.veriperson.isShow = true;

          // console.log(11111111111111);
          console.log('55555555555',this.veriperson.selectedList);
        });
      }
    });
  },





    // 获取图片上传的地址
    wGetUploadImgPath() {
      return `${process.env.VUE_APP_URE}/file/uploadFile`;
    },
    // 图片预览
    wELUpload_preview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 删除图片
    wELUpload_remove(file, fileList) {
      console.log(file, fileList);
    },
    // 图片上传成功
    wELUpload_success(response, file, fileList) {
      console.log(response);
    },
    // 图片上传失败
    wELUpload_error(err, file, fileList) {
      console.log(err);
      this.$message("图片上传失败");
    },
    // 超出图片上传限制
    wELUpload_limit(files, fileList) {
      this.$message("图片上传已达上限");
    },
    // 图片上传之前做限制
    wELUpload_beforeUpload(file) {
      this.loading = true;
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      // const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG 或者 PNG 格式!");
      }
      return isJPG || isPNG;
    },
    /**
     * wELUpload_success_cover
     * 商品主图上传成功
     */
    wELUpload_success_cover(response, file, fileList) {
      console.log(response, file, fileList);
      // 数据处理
      let imgArr = this.wStoreDialog.form.imgCover.list;
      imgArr.push({
        name: file.name,
        url: file.response.data
      });
      // 更新数据
      this.wStoreDialog.form.imgCover.list = imgArr;
    },
    /**
     * wELUpload_remove_cover
     * 删除商品主图图片
     */
    wELUpload_remove_cover(file, fileList) {
      console.log(file, fileList);
      // 数据处理
      let imgArr = [];
      for (let i = 0; i < fileList.length; i++) {
        if (fileList[i].response) {
          imgArr.push({
            name: fileList[i].name,
            url: fileList[i].response.data
          });
        } else {
          imgArr.push({
            name: fileList[i].name,
            url: fileList[i].url
          });
        }
      }
      // 更新数据
      this.wStoreDialog.form.imgCover.list = imgArr;
    },
    /**
 * wELUpload_success_album
 * 营业执照图片上传成功
 */

    /**
     * wELUpload_success_album
     * 商品相册图片上传成功
     */
    wELUpload_success_album(response, file, fileList) {
      console.log(response, file, fileList);
      // 数据处理
      let imgArr = this.wStoreDialog.form.imgAlbum.list;
      imgArr.push({
        name: file.name,
        url: file.response.data
      });
      // 更新数据
      this.wStoreDialog.form.imgAlbum.list = imgArr;
    },

    /**
     * wELUpload_remove_album
     * 删除商品相册图片
     */
    wELUpload_remove_album(file, fileList) {
      console.log(file, fileList);
      // // 数据处理
      let imgArr = [];
      for (let i = 0; i < fileList.length; i++) {
        if (fileList[i].response) {
          imgArr.push({
            name: fileList[i].name,
            url: fileList[i].response.data
          });
        } else {
          imgArr.push({
            name: fileList[i].name,
            url: fileList[i].url
          });
        }
      }
      // 更新数据
      this.wStoreDialog.form.imgAlbum.list = imgArr;
    },
    /**
     * wDoChoiceColumn
     * 栏目选择
     */
    wDoChoiceColumn(wP_id) {
      this.wColumn.value = wP_id;
      // 获取门店列表数据
      this.wGetStoreList();
    },

    /**
     * wGetStoreList
     * 获取门店列表数据
     */
    wGetStoreList() {
      this.tableLoading = true
      let { value: wStoreType } = this.wColumn;
      let { page, limit } = this.wCategory;

      // 请求参数
      let wData = {};

      // 门店类型 1-旗舰店 2-中心店 3-社区店
      if (wStoreType != 0) {
        wData.type = wStoreType;
      }
      wData["pageModel.pageNo"] = page;
      wData["pageModel.pageSize"] = limit;

      // 请求函数
      this.$api.store_list({
        data: wData,
        success: res => {
          // 更新数据
          this.tableLoading = false
          this.wCategory.total = res.total;
          this.wCategory.list = res.records;
          console.log("门店数据", res.records);
          console.log("门店长度", res.records.length);
          console.log("门店total", res.total);

          console.log("门店数据2", res.records.veriperson);

          for (let i = 0; i < this.wCategory.list.length; i++) {
            if (this.wCategory.list[i].veriperson !== null) {
              console.log(5, this.wCategory.list[i].veriperson !== null);
              const veripersonIds = this.wCategory.list[i].veriperson.split(',');

              const promises = veripersonIds.map((id) => getUserInfoById(id));

              Promise.all(promises).then((results) => {
                // console.log(88888888888888, results);
                const array = [];
                results.forEach((res) => {
                  if (res && res.baseUserVo) {
                    array.push(res.baseUserVo.phone);
                  } else {
                    array.push('');
                  }
                });
                let str = '';
                if (array.length > 0) {
                  str = array.join(",");
                  // console.log(777777777, str);
                }
                
                // 使用 Vue.set 或 this.$set 确保响应式更新
                this.$set(this.wCategory.list[i], 'UserPhone', str);
              }).catch((error) => {
                console.error("没有核销负责人手机号", error);
                this.$set(this.wCategory.list[i], 'UserPhone', '');
              });
            } else {
              this.$set(this.wCategory.list[i], 'UserPhone', '');
            }
          } 
              
          //     // getUserInfoById(this.wCategory.list[i].veriperson).then((res)=>{
          //     //   console.log(res.baseUserVo.phone);
          //     //   // this.wStoreDialog.form.UserPhone=res.baseUserVo.phone;
          //     //   this.wCategory.list[i].UserPhone=res.baseUserVo.phone;
          //     // })
          //   }else{
          //     this.wCategory.list[i].UserPhone='';
          //   }
          // }
          

          // this.wStoreDialog.form.idsArray = (res.veriperson || '').split(',').filter(id => id);
          // this.wStoreDialog.form.phones = [];
          // for (const id of this.wStoreDialog.form.idsArray) {
          //   const memberInfo = this.wGetStoreInfoById(id);
          //   if (memberInfo?.phone) phones.push(memberInfo.phone);
          // }
          
          // this.wStoreDialog.form.veripersonName = this.wStoreDialog.form.phones.join(',');
          // console.log('手机号:', this.wStoreDialog.form.veripersonName);
          
        }
      });
    },
    /**
     * wELPageCurrentChange
     * 分页 currentPage 改变时会触发 - 当前页
     */
    wELPageCurrentChange(wP_cPage) {
      this.wCategory.page = wP_cPage;
      // 获取门店列表数据
      this.wGetStoreList();
    },
    /**
     * wELPageSizeChange
     * 分页 pageSize 改变时会触发 - 每页条数
     */
    wELPageSizeChange(wP_cPageSize) {
      this.wCategory.page = 1;
      this.wCategory.limit = wP_cPageSize;
      // 获取门店列表数据
      this.wGetStoreList();
    },

    /**
     * wDoTableBtn
     * 表格操作按钮
     */
    wDoTableBtn(wP_scope, wP_type) {
      console.log("123123", wP_scope, wP_type);
      let wIndex = wP_scope.$index;
      switch (wP_type) {
        case `add`:
          // 新增一个门店
          {
            // 清空数据
            this.wStoreDialog.form.startTime = "";
            this.wStoreDialog.form.endTime = "";
            this.wStoreDialog.form.id = "";
            this.wStoreDialog.form.storeName = "";
            this.wStoreDialog.form.sn = [];
            this.wStoreDialog.form.category.value = "";
            this.wStoreDialog.form.beneficiary="";
            this.wStoreDialog.form.UserPhone="";
            this.wStoreDialog.form.veripersonName="";
            this.wStoreDialog.form.veriperson="";
            this.wStoreDialog.form.pickupperson="";
            this.wStoreDialog.form.PickupPhone="";
            this.wStoreDialog.form.pickuppersonName="";
            this.wStoreDialog.form.quality="";
            this.wStoreDialog.form.delivery="";
            this.wStoreDialog.form.corresponding="";
            this.wStoreDialog.form.isBreakEven = 0;
            this.wStoreDialog.form.type = ["QNXM"];
            this.wStoreDialog.form.atype = 1;
            this.wStoreDialog.form.turnover = null;
            this.pickupperson.selectedList = [];
            // 门店主图
            this.wStoreDialog.form.imgCover.list = [];
            this.wStoreDialog.form.imgCover.list_v = [];
            // 门店图片
            this.wStoreDialog.form.imgAlbum.list = [];
            this.wStoreDialog.form.imgAlbum.list_v = [];
            this.wStoreDialog.isShow = true;
          }
          break;

        case `business`:
          // 门店开业与关业的管理
          {
            let { id } = wP_scope.row;
            // 请求函数
            this.$api.store_operateBusiness({
              data: {
                id: id
              },
              success: res => {
                console.log(res);
                this.$message({
                  type: "success",
                  message: "修改成功!"
                });
                this.wCategory.list[wIndex].openOrClose = res.openOrClose;
                this.wCategory.list[wIndex].openOrCloseName =
                  res.openOrCloseName;
              }
            });
          }
          break;

        case `delete`:
          // 门店删除
          {
            let { id } = wP_scope.row;
            this.$confirm("此操作将永久删除该门店, 是否继续?", "删除门店", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                // 请求函数
                deleteStoreApi(id)
                  .then(res => {
                    // 获取门店列表数据
                    this.wGetStoreList();
                    this.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                  })
                  .catch(err => {
                    // this.$message({
                    //   type: "error",
                    //   message: "删除失败!"
                    // });
                  });
              })
              .catch(() => { });
          }
          break;

        case `edit`:
          // 修改信息
          {
            // 获取门店详情
            this.wGetStoreInfoById(wP_scope.row.id)
              .then(res => {
                // 更改数据
                console.log(333333333,res);
                this.wStoreDialog.form.startTime = res.startTime;
                this.wStoreDialog.form.endTime = res.endTime;
                this.wStoreDialog.form.id = res.id;
                this.wStoreDialog.form.storeName = res.storeName;
                this.wStoreDialog.form.sn = res.sn ? res.sn.split(',') : [];
                this.wStoreDialog.form.address = res.address;
                this.wStoreDialog.form.tel = res.tel;
                this.wStoreDialog.form.bankCard = res.bankCard;
                this.wStoreDialog.form.beneficiary = wP_scope.row.beneficiary;
                this.wStoreDialog.form.beneficiaryName =wP_scope.row.beneficiaryName;

                this.wStoreDialog.form.UserPhone =res.UserPhone;
                // this.wStoreDialog.form.veripersonName =res.UserPhone;
                this.wStoreDialog.form.veriperson = res.veriperson || '';
                this.wStoreDialog.form.pickupperson = res.pickupperson || '';
                this.wStoreDialog.form.quality = res.quality || '';
                this.wStoreDialog.form.delivery = res.delivery || '';
                this.wStoreDialog.form.corresponding = res.corresponding || '';
                this.wStoreDialog.form.isBreakEven = res.isBreakEven != null ? res.isBreakEven : 0;
                this.wStoreDialog.form.type = res.type ? res.type.split(',') : ["QNXM"];
                this.wStoreDialog.form.atype = res.atype || 1;
                this.wStoreDialog.form.turnover = res.turnover != null ? res.turnover : null;
                if (res.pickupperson) {
                  const pids = res.pickupperson.split(',').filter(Boolean);
                  const promises = pids.map(id => getUserInfoById(id));
                  Promise.all(promises).then(results => {
                    const phones = [];
                    const names = [];
                    results.forEach(r => {
                      if (r && r.baseUserVo) {
                        phones.push(r.baseUserVo.phone || '');
                        names.push(r.baseUserVo.nickName || '');
                      } else {
                        phones.push('');
                        names.push('');
                      }
                    });
                    this.wStoreDialog.form.PickupPhone = phones.join(',');
                    this.wStoreDialog.form.pickuppersonName = names.join(',');
                  }).catch(()=>{ 
                    this.wStoreDialog.form.PickupPhone = ''; 
                    this.wStoreDialog.form.pickuppersonName = '';
                  });
                } else {
                  this.wStoreDialog.form.PickupPhone = '';
                  this.wStoreDialog.form.pickuppersonName = '';
                }

                // 门店主图
                this.wStoreDialog.form.imgCover.list = [];
                this.wStoreDialog.form.imgCover.list_v = [];

                if (res.headImage) {
                  this.wStoreDialog.form.imgCover.list = [
                    {
                      name: "门店主图",
                      url: res.headImage
                    }
                  ];
                  this.wStoreDialog.form.imgCover.list_v = [
                    {
                      name: "门店主图",
                      url: res.headImage
                    }
                  ];
                }
                this.wStoreDialog.isShow = true;
              })
              .catch(err => { });
          }
          break;

        default:
          this.$message("功能待开发~");
          break;
      }
    },

    /**
     * wDoUpdateStore
     * 更新门店数据
     */
    wDoUpdateStore() {
      // 请求函数
      store_storeUpdate().then(res => {
        this.$message({
          message: "门店数据更新成功~",
          type: "success"
        });
        // 获取门店列表数据
        this.wGetStoreList();
      });
    },

    /**
     * wToTableList
     * 跳转至门店桌子列表数据
     */
    wToTableList(e) {
      // 跳转至门店桌子列表页面
      this.$router.push({
        name: "storeTable",
        query: { sid: e.id, name: e.storeName }
      });
    },

    /**
     * wGetStoreInfoById
     * 通过门店id获取商品详情
     */

    wGetStoreInfoById(wP_id) {
      return new Promise((resolve, reject) => {
        store_storeInfoById({
          id: wP_id
        })
          .then(res => {
            console.log(2222222222222, res);
            
            // 添加空值检查
            if (!res.veriperson) {
              res.UserPhone = '';
              resolve(res);
              return;
            }
            const veripersonIds = res.veriperson.split(',');      
            const promises = veripersonIds.map((id) => getUserInfoById(id));
            this.veriperson.id=veripersonIds;
            // console.log('1234',this.veriperson.id);
            Promise.all(promises).then((results) => {
              const array = [];
              results.forEach((res) => {
                if (res && res.baseUserVo) {
                  array.push(res.baseUserVo.phone);
                } else {
                  array.push('');
                }
              });
              
              let str = '';
              if (array.length > 0) {
                str = array.join(",");
                console.log(777777777, str);
              }
              res.UserPhone = str;
              
              resolve(res);
            }).catch(err => {
              // 处理获取用户信息时的错误
              reject(err);
            });
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    // wGetStoreInfoById(wP_id) {
    //   return new Promise((resolve, reject) => {
    //     // 请求函数
    //     store_storeInfoById({
    //       id: wP_id
    //     })
    //       .then(res => {
    //         console.log(2222222222222,res);
    //         // console.log(33333,res.veriperson);

    //         const veripersonIds = res.veriperson.split(',');      
    //         const promises = veripersonIds.map((id) => getUserInfoById(id));
    //         Promise.all(promises).then((results) => {
    //           const array = [];
    //           results.forEach((res) => {
    //             if (res && res.baseUserVo) {
    //               array.push(res.baseUserVo.phone);
    //             } else {
    //               array.push('');
    //             }
    //           });
    //           let str = '';
    //           if (array.length > 0) {
    //             str = array.join(",");
    //             console.log(777777777, str);
    //           }
    //           res.UserPhone=str;
    //           resolve(res);
    //         })
    //       //   for (let i = 0; i < this.wCategory.list.length; i++) {
    //       //   if (this.wCategory.list[i].veriperson !== null) {
    //       //     console.log(5, this.wCategory.list[i].veriperson !== null);
    //       //     const veripersonIds = this.wCategory.list[i].veriperson.split(',');

    //       //     const promises = veripersonIds.map((id) => getUserInfoById(id));

    //       //     Promise.all(promises).then((results) => {
    //       //       console.log(88888888888888, results);
    //       //       const array = [];
    //       //       results.forEach((res) => {
    //       //         if (res && res.baseUserVo) {
    //       //           array.push(res.baseUserVo.phone);
    //       //         } else {
    //       //           array.push('');
    //       //         }
    //       //       });
    //       //       let str = '';
    //       //       if (array.length > 0) {
    //       //         str = array.join(",");
    //       //         console.log(777777777, str);
    //       //       }
                
    //       //       // 使用 Vue.set 或 this.$set 确保响应式更新
    //       //       this.$set(this.wCategory.list[i], 'UserPhone', str);
    //       //     }).catch((error) => {
    //       //       console.error("没有核销负责人手机号", error);
    //       //       this.$set(this.wCategory.list[i], 'UserPhone', '');
    //       //     });
    //       //   } else {
    //       //     this.$set(this.wCategory.list[i], 'UserPhone', '');
    //       //   }
    //       // }
            
    //       })
    //       .catch(err => {
    //         reject(err);
    //       });
    //   });
    // },

    /**
     * wDoStoreDialogOperate
     * 修改门店信息
     */
    wDoStoreDialogOperate() {
      // 请求参数
      let wData = {};

      // 表单数据
      let {
        id: wS_id,
        category: { value: wS_type },
        imgCover: { list: wS_imgCoverArr },
        imgAlbum: { list: wS_imgAlbumArr },
        // license:  { list: wS_licenseArr}
      } = this.wStoreDialog.form;

      // 数据处理
      // 门店id主键
      wData.id = wS_id || "";
      // 门店类型 1-旗舰店 2-中心店 3-社区店
      // wData.type = wS_type;
      // wData.type = 1; // 已废弃，使用用户选择的字符串type

      // 经度纬度
      wData.lon = this.wStoreDialog.form.lon;
      wData.lat = this.wStoreDialog.form.lat;
      // 门店主要信息
      wData.storeName = this.wStoreDialog.form.storeName;
      wData.address = this.wStoreDialog.form.address;
      wData.sn = this.wStoreDialog.form.sn.join(',');
      wData.bankCard = this.wStoreDialog.form.bankCard;
      wData.tel = this.wStoreDialog.form.tel;
      wData.startTime = this.wStoreDialog.form.startTime;
      wData.endTime = this.wStoreDialog.form.endTime;
      wData.beneficiary = this.wStoreDialog.form.beneficiary;

      wData.veriperson = this.wStoreDialog.form.veriperson;
      wData.pickupperson = this.wStoreDialog.form.pickupperson;
      wData.quality = this.wStoreDialog.form.quality;
      wData.delivery = this.wStoreDialog.form.delivery;
      wData.corresponding = this.wStoreDialog.form.corresponding;
      wData.isBreakEven = this.wStoreDialog.form.isBreakEven;
      wData.type = Array.isArray(this.wStoreDialog.form.type) ? this.wStoreDialog.form.type.join(',') : this.wStoreDialog.form.type;
      wData.atype = this.wStoreDialog.form.atype;
      // 只有在 atype 为师徒制(旧改店)(2)或师徒制(合作店)(3)时才提交营业额
      if (this.wStoreDialog.form.atype === 2 || this.wStoreDialog.form.atype === 3) {
        wData.turnover = this.wStoreDialog.form.turnover;
      } else {
        wData.turnover = null;
      }
      // 地址
      if (!wData.address) {
        this.$message({
          message: "请填写门店地址",
          type: "error"
        });
        return;
      }

      // 银行卡号
      if (!wData.bankCard) {
        this.$message({
          message: "请填写银行卡号",
          type: "error"
        });
        return;
      }

      // 门店主图
      if (wS_imgCoverArr.length == 0) {
        this.$message({
          message: "请选择门店主图",
          type: "error"
        });
        return;
      }

      wData.headImage = wS_imgCoverArr[0].url;

      wData.images = [];
      wS_imgAlbumArr.forEach((value, index) => {
        wData.images.push(value.url);
      });

      // 请求函数
      wData.id
      console.log("新增门店表单", wData)
        ? store_editStoreInfo(wData).then(res => {
          console.log(res);
          // 操作成功
          this.$message({
            message: "修改成功",
            type: "success"
          });
          // 关闭弹框
          this.wStoreDialog.isShow = false;
          // 获取门店列表数据
          this.wGetStoreList();
        })
          .catch(err => {
            console.log(err);
          })
        : store_addStoreInfo(wData).then(res => {
          console.log(res);
          // 操作成功
          this.$message({
            message: "新增成功",
            type: "success"
          });
          // 关闭弹框
          this.wStoreDialog.isShow = false;
          // 获取门店列表数据
          this.wGetStoreList();
          this.wStoreDialog.form.veriperson = null;
          this.wStoreDialog.form.pickupperson = null;
        })
          .catch(err => {
            console.log(err);
          });
    },
    /**
     * wStoreDialogClose
     * 修改门店信息弹框-Dialog 关闭的回调
     */
    wStoreDialogClose() {
      
      // 重置数据
      this.wStoreDialog.form.id = 0;
      this.wStoreDialog.form.storeName = "";
      this.wStoreDialog.form.address = "";
      this.wStoreDialog.form.sn = "";
      this.wStoreDialog.form.bankCard = "";
      this.wStoreDialog.form.tel = "";
      this.wStoreDialog.form.category.value = "";
      this.wStoreDialog.form.imgCover.list = [];
      this.wStoreDialog.form.imgCover.list_v = [];
      this.wStoreDialog.form.imgAlbum.list = [];
      this.wStoreDialog.form.imgAlbum.list_v = [];

      this.beneficiary.keyword = "";
      this.beneficiary.page = 1;
      this.beneficiary.limit = 10;
      this.beneficiary.total = 0;

      this.veriperson.keyword = "";
      this.veriperson.page = 1;
      this.veriperson.limit = 10;
      this.veriperson.total = 0;
      this.pickupperson.keyword = "";
      this.pickupperson.page = 1;
      this.pickupperson.limit = 10;
      this.pickupperson.total = 0;
      this.pickupperson.selectedList = [];
    }
  }
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publicStyle.less";

.selected-persons-area {
  display: flex;
  align-items: flex-start;
  padding: 12px;
  background-color: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 16px;
}

.selected-persons-label {
  font-size: 14px;
  color: #606266;
  margin-right: 12px;
  line-height: 32px;
  white-space: nowrap;
}

.selected-persons-tags {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

// 商品分类区域
.wGC-categoryArea {
  display: block;
  width: 100%;
  padding: 20px 16px;
  box-sizing: border-box;
  background-color: #ffffff;

  .wGC-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    // 栏目
    .wGCH-column {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      user-select: none;

      .wGCHC-item {
        flex: none;
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        margin-right: 10px;
        box-sizing: border-box;
        background-color: #f3f3f3;
        // border: 1px solid #999999;
        font-size: @wFontSize;
        cursor: pointer;
        transition: all 0.3s;

        &:hover,
        &.wActive {
          background-color: @wColor_theme;
          border-color: @wColor_theme;
          color: #ffffff;
        }
      }
    }
  }

  // 商品分类数据
  .wGC-categoryList {
    display: block;
    width: 100%;

    // table表
    .wGLG-table {
      display: block;
      width: 100%;

      .isOpenOrClose {
        color: @wColor_theme;
      }
    }

    // 分页
    .wGLG-page {
      display: block;
      width: 100%;
      margin-top: 20px;
      text-align: center;
    }
  }
}

// 职务信息表单
.wDialogForm {
  display: block;
  width: 100%;
  height: 450px;

  .wDialogForm-box {
    display: block;
    width: 100%;
    box-sizing: border-box;
  }
}

.wETJRFTable-user {
  display: flex;
  align-items: center;

  .wETJRFTable-userName {
    margin-left: 10px;
  }
}
</style>

